import attack from '../../request/request'
import { EMER, BASIC } from '../../data/requers_variable.js'
import emergency from '../../components/burst/emergency.vue';
export default {
  /**
   * 风险等级
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  risklevel_list(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/risklevel/list`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  // 保存企业
  save_entInfo(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${EMER}/sudden/ent/info/save`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  // 保存政府
  save_govInfo(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${EMER}/sudden/gov/info/save`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  // 保存工业园区
  save_parkInfo(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${EMER}/sudden/zone/info/save`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  // 保存水源地
  save_waterInfo(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${EMER}/sudden/water/info/save`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  // 保存其他
  save_otherInfo(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${EMER}/sudden/other/info/save`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  // 风险物资搜索
  material_search(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${BASIC}/material/search`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  // 风险物资保存
  material_save(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${EMER}/material/risk/create`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  // 风险物资列表
  material_lists(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/material/risk/list`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  // 删除
  material_delect(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${EMER}/material/risk/delete`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  // 编辑
  material_modify(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${EMER}/material/risk/modify`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  // 应急队伍列表
  emerteamrole_list() {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/emerteamrole/list`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  // 突发备案基本信息保存
  sudden_save(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${EMER}/sudden/ent/info/basic/save`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          reject({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  // 应急物资列表
  supply_tree() {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${BASIC}/supply/tree`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  // 应急物资保存
  supplymaterila_save(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'POST',
        data: params,
        url: `${EMER}/material/emer/save`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  // 敏感保护目标信息保存(单页面)
  sensprotection_save(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'POST',
        data: params,
        url: `${EMER}/sensprotection/save`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          reject({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  // 敏感保护目标信息保存(单页面)
  planich_list(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        data: params,
        url: `${EMER}/planich/list`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          reject({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  // 应急物资列表
  supply_tree() {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${BASIC}/supply/tree`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  // 应急物资保存
  supplymaterila_save(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'POST',
        data: params,
        url: `${EMER}/material/emer/save`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  // 应急队伍保存
  team_save(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'POST',
        data: params,
        url: `${EMER}/team/emer/save`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  // 工艺和环境风险控制操作
  risk_save(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'POST',
        data: params,
        url: `${EMER}/control/risk/create`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          reject({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  // 获取工艺和环境风险控制操作
  risk_detail(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        data: params,
        url: `${EMER}/control/risk/detail`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          reject({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  // 基本信息详情
  get_basic_detail(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        data: params,
        url: `${EMER}/sudden/ent/info/basic/detail`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          reject({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  // GET
  // 敏感保护目标相关操作接口
  get_sensprotection_list(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        data: params,
        url: `${EMER}/sensprotection/list`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          reject({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
    // GET
  // 敏感保护目标相关操作接口
  get_sensprotection_detail(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        data: params,
        url: `${EMER}/sensprotection/detail`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          reject({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  // /team/emer/list

  // 应急队伍
  get_team_lists(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        data: params,
        url: `${EMER}/team/emer/list`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          reject({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  // 获取工艺和环境风险控制操作
  risk_detail(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        data: params,
        url: `${EMER}/control/risk/detail`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          reject({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  // 应急物资列表
  get_material_list(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        data: params,
        url: `${EMER}/material/emer/list`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          reject({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  // 删除案例文件
  remove_plancase(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        data: params,
        url: `${EMER}/plancase/delete`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          reject({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  // 案例文件列表
  plancase_list(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        data: params,
        url: `${EMER}/plancase/list`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          reject({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  // 删除平面图
  remove_planich(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        data: params,
        url: `${EMER}/planich/delete`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          reject({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  // 大开始
  // 基本信息详情
  get_basic_detail(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        data: params,
        url: `${EMER}/sudden/ent/info/basic/detail`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          reject({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  // 风险物质列表
  material_lists(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/material/risk/list`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  // 风险物质列表
  material_listss(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/material/emer/list`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  // 应急物资列表
  supply_tree() {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${BASIC}/supply/tree`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  // 获取工艺和环境风险控制操作
  risk_detail(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        data: params,
        url: `${EMER}/control/risk/detail`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          reject({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  // 应急队伍
  get_team_lists(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        data: params,
        url: `${EMER}/team/emer/list`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          reject({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  // GET
  // 敏感保护目标相关操作接口
  get_sensprotection_list(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        data: params,
        url: `${EMER}/sensprotection/list`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          reject({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  // 平面图
  planich_list(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        data: params,
        url: `${EMER}/planich/list`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          reject({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  // 案例
  plancase_list(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        data: params,
        url: `${EMER}/plancase/list`,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          reject({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  get_last_succ_plan_risk_level(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/sudden/ent/info/getLastSuccPlanRiskLevel`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
}



// WEBPACK FOOTER //
// ./src/data/emer/burst.js